import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import {ToastContainer, toast, Slide} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
// import { useAuth0 } from '@auth0/auth0-react';

import FeatureSelect from '../../components/FormPage/FeatureSelect';
import FormSubmitButton from '../../components/FormPage/FormSubmitButton';
import VersionDetailSelect from '../../components/FormPage/VersionDetailSelect';

export default function NewVersionForm({ features }) {
    // const { isAuthenticated } = useAuth0();
    const [fromDate, setFromDate] = useState(new Date('2020/06/30'));
    const [toDate, setToDate] = useState(new Date('2020/06/30'));
    const [filteredFeatures, setFilteredFeatures] = useState(features)
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [description, setDescription] = useState('');
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const [createdVersion, setCreatedVersion] = useState('');
    const [target, setTarget] = useState('Party')

    const handleSubmit = () => {
        if (fromDate >= toDate) {
            toast('Start date cannot be before end date.')
        } else if (!selectedFeatures.length) {
            toast('You must select at least one feature.')
        } else {
            try {
                axios.post('/api/newversion', {fromDate, toDate, description, target, features: selectedFeatures.map(feature => feature.queryId)})
                    .then(r => {
                        setCreatedVersion(r.data.Version);
                    })
            } catch (err) {
                toast('There was an error with the database. Please try again later.')
            }
        }
    }

    useEffect(() => {
        if (createdVersion) {
            setShouldRedirect(true);
        }
    }, [createdVersion])

    useEffect(() => {
        setFilteredFeatures(features.filter(feature => feature.IdType === target));
        setSelectedFeatures([]);
    }, [features, target])

    if (shouldRedirect) {
        return <Redirect to={{
            pathname: "/version",
            state: {version: description}
        }} />
    }

    // if (isAuthenticated) {
        return (
            <>
                <div className="p-6 w-4/5" style={{marginLeft: "8rem"}}>
                    <ToastContainer
                        position="top-center"
                        transition={Slide}
                        hideProgressBar={true}
                        bodyClassName="text-gray-600"
                        progressClassName="bg-purple-500"
                    />
                    <h1 className="text-3xl py-4 px-3 ml-5 border-b mb-10">Create Version</h1>
                    <VersionDetailSelect
                        fromDate={fromDate}
                        setFromDate={setFromDate}
                        toDate={toDate}
                        setToDate={setToDate}
                        description={description}
                        setDescription={setDescription}
                        target={target}
                        setTarget={setTarget}
                    />
                    <FeatureSelect features={features} filteredFeatures={filteredFeatures} selectedFeatures={selectedFeatures} setFeatures={setSelectedFeatures} setFilteredFeatures={setFilteredFeatures} />
                    <FormSubmitButton handleSubmit={handleSubmit} />
                </div>
            </>
        )
    // }

    return (
        <div className="flex flex-col justify-center items-center p-6 w-4/5">
            <span className="text-2xl">You must be logged in to create new features.</span>
        </div>
    )
}
